// import { useFlags } from 'launchdarkly-react-client-sdk';
import { Control } from 'react-hook-form';

import {
  RequestSchemaAssignedAccount,
  RequestSchemaAssignedContactsItem,
} from '@liscio/api';
import { RecipientSelector } from '@liscio/common';

/**import { AccountContactSelectorWithControl } from 'components/AccountContactSelector';
*/

type RequestRecipientSelectorProps = {
  name?: string;
  control?: Control;
  account?: RequestSchemaAssignedAccount;
  assignedContacts?: RequestSchemaAssignedContactsItem[];
  required?: boolean;
  disabled?: boolean;
  disableRemoval?: boolean;
  helperMessage?: string;
  maxHeight?: string;
};

/**
 * Wrapper component for request recipient selection that uses either:
 * - New AccountContactSelectorField (behind firmContactSelector flag)
 * - Old RecipientSelector (default)
 */
export function RequestRecipientSelector({
  name = 'recipients',
  control,
  account,
  assignedContacts = [],
  required,
  disabled,
  disableRemoval,
  helperMessage,
  maxHeight,
}: RequestRecipientSelectorProps) {
  // const flags = useFlags();
  // const useFirmContactSelector = flags?.firmContactSelector === true;

  // if (useFirmContactSelector && control) {
  //   return (
  //     <AccountContactSelectorWithControl
  //       name="assignedContactIds"
  //       label="ASSIGNEES"
  //       placeholder="Type to search contacts..."
  //       disabled={disabled}
  //       control={control}
  //     />
  //   );
  // }

  return (
    <RecipientSelector
      name={name}
      control={control}
      account={account}
      assignedContacts={assignedContacts}
      required={required}
      disabled={disabled}
      disableRemoval={disableRemoval}
      helperMessage={helperMessage}
      maxHeight={maxHeight}
    />
  );
}

